import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

export function PremiumPage() {
  const [params] = useSearchParams();
  const { user, loading } = useAuth();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  useEffect(() => {
    const sessionId = params.get('session_id');
    const success = params.get('success');
    if (success === '1' && sessionId && user) {
      api('/economy/verify-session', {
        method: 'POST',
        body: JSON.stringify({ sessionId }),
      }).then(() => {
        setMsg(t('premium.activated'));
      }).catch(() => setMsg(t('premium.verifyRefresh')));
    }
    if (params.get('canceled') === '1') {
      setMsg(t('premium.canceled'));
    }
  }, [params, user]);

  const handleCheckout = async () => {
    setBusy(true);
    setMsg('');
    try {
      const res = await api<{ url: string }>('/economy/create-checkout-session', { method: 'POST' });
      window.location.href = res.url;
    } catch (e: unknown) {
      const err = e as { data?: { error?: string } };
      setMsg(err.data?.error === 'payments_not_configured'
        ? t('premium.paymentsNotConfigured')
        : t('premium.checkoutError'));
    } finally {
      setBusy(false);
    }
  };

  if (loading) {
    return <main className="page premium"><p className="loading">{t('common.loading')}</p></main>;
  }

  return (
    <main className="page premium">
      <div className="result-card premium-card">
        <h1>{t('premium.title')}</h1>
        <p className="premium-price">{t('premium.price')}</p>
        <ul className="premium-perks">
          <li>{t('premium.perk1')}</li>
          <li>{t('premium.perk2')}</li>
          <li>{t('premium.perk3')}</li>
        </ul>

        {user?.isPremium ? (
          <p className="premium-active">{t('premium.active')}</p>
        ) : user ? (
          <>
            <label className="premium-terms">
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
              />
              <span>
                {t('premium.termsPrefix')}{' '}
                <Link to="/cgv">{t('legal.cgv')}</Link>
                {' '}{t('premium.termsAnd')}{' '}
                <Link to="/cgu">{t('legal.cgu')}</Link>
                . {t('premium.consent')}
              </span>
            </label>
            <div className="premium-checkout-actions">
              <button
                type="button"
                className="btn primary block"
                onClick={handleCheckout}
                disabled={busy || !acceptedTerms}
              >
                {busy ? t('premium.redirecting') : t('premium.subscribe')}
              </button>
              <Link to="/login" className="link-muted premium-already-link">{t('premium.alreadyPremium')}</Link>
            </div>
          </>
        ) : (
          <Link to="/login" className="btn primary">{t('premium.loginFirst')}</Link>
        )}

        {msg && <p className="premium-msg">{msg}</p>}
      </div>
      <nav className="result-nav">
        <Link to="/play">{t('nav.daily')}</Link>
        <Link to="/">{t('gallery.home')}</Link>
      </nav>
    </main>
  );
}
